(() => {
  if (window.ukrLanderCartLoaded) return;
  window.ukrLanderCartLoaded = true;
  const installationIds = new Set(['15199352848757','15224078991733','15224080040309']);
  const shopRoot = () => window.Shopify?.routes?.root || '/';
  function bindPopup(popup, button) {
    popup.ukrReturnFocus = button;
    if (popup.dataset.ukrLanderBound) return;
    popup.dataset.ukrLanderBound = 'true';
    popup.setAttribute('role', 'dialog'); popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', popup.querySelector('.popup__heading')?.textContent || 'Basket');
    popup.tabIndex = -1;
    const close = () => { popup.style.display = 'none'; popup.ukrReturnFocus?.focus(); };
    popup.addEventListener('click', e => { if (e.target === popup || e.target.closest('.close, .close__btn')) close(); });
    popup.querySelectorAll('.close, .close__btn').forEach(el => {
      el.tabIndex = 0; el.setAttribute('role','button');
      el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); } });
    });
    popup.addEventListener('keydown', e => {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const nodes = [...popup.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled):not([type="hidden"]),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { e.preventDefault(); popup.focus(); }
      else if (e.shiftKey && (document.activeElement === first || document.activeElement === popup)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || document.activeElement === popup)) { e.preventDefault(); first.focus(); }
    });
  }
  function boot(scope = document) {
    scope.querySelectorAll('[data-ukr-lander]').forEach(root => {
      const form = root.querySelector('.ukr-mtb__product-form');
      if (!form || form.dataset.ukrCartBound) return;
      form.dataset.ukrCartBound = 'true';
      const labels = JSON.parse(root.dataset.cartLabels);
      const feedback = root.querySelector('[data-lander-cart-status]');
      let busy = false, uncertain = false;
      function review(message) {
        feedback.textContent = message + ' ';
        const link = document.createElement('a'); link.href = shopRoot() + 'cart'; link.textContent = labels.review;
        feedback.appendChild(link);
      }
      form.addEventListener('submit', async event => {
        event.preventDefault(); event.stopImmediatePropagation();
        if (busy || uncertain) return;
        const data = new FormData(form);
        if (!data.get('id')) { feedback.textContent = labels.select; return; }
        busy = true; feedback.textContent = labels.adding;
        const controls = [...root.querySelectorAll('button[type="submit"], select, input')];
        const disabled = controls.map(el => el.disabled);
        controls.forEach(el => { el.disabled = true; });
        const submitter = event.submitter || form.querySelector('[type="submit"]');
        let added;
        try {
          const response = await fetch(shopRoot() + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:data});
          const result = await response.json();
          if (!response.ok) {
            if (response.status >= 400 && response.status < 500) { feedback.textContent = result.description || result.message || labels.failed; return; }
            throw new Error('Unconfirmed cart response');
          }
          added = result.items ? result.items[0] : result;
          if (!added?.key) throw new Error('Missing cart line');
          feedback.textContent = labels.added;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:added,addToCartBtn:submitter,source:'ukr-lander'}}));
          const popup = document.querySelector('.popup');
          if (!popup) { review(labels.added); return; }
          const item = popup.querySelector('.popup__item');
          const title = added.product_title || added.title;
          const url = added.url || root.dataset.productUrl;
          const image = item?.querySelector('.popup__product-img');
          if (image) { image.src = added.featured_image?.url || added.image || root.querySelector('.ukr-mtb__selected-image')?.src || ''; image.alt = title; }
          item?.querySelectorAll('.popup__item-img-a, .popup__item-title-a').forEach(el => { el.href = url; });
          const titleLink = item?.querySelector('.popup__item-title-a');
          if (titleLink) titleLink.textContent = title + (added.variant_title ? ' — ' + added.variant_title : '');
          const price = item?.querySelector('.product-pricing');
          if (price) {
            const text = document.createElement('span'); text.className = 'discounted-price';
            text.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:root.dataset.currency}).format((added.final_price ?? added.price)/100);
            price.replaceChildren(text);
          }
          item?.querySelectorAll('.amountSaved').forEach(el => el.remove());
          bindPopup(popup, submitter);
          popup.style.display = 'block';
          window.theme?.a11y?.removeTrapFocus?.({container:document.getElementById('CartDrawerForm'),namespace:'cartdrawer_focus'});
          popup.focus();
          popup.querySelectorAll('.swiper').forEach(el => el.swiper?.update());
          popup.querySelectorAll('.summary__subtotal-place').forEach(el => { el.textContent = '…'; });
          try {
            const response = await fetch(shopRoot() + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
            if (!response.ok) throw new Error('Summary refresh failed');
            const cart = await response.json();
            const count = cart.items.reduce((sum,item) => sum + (installationIds.has(String(item.product_id)) ? 0 : item.quantity),0);
            popup.querySelectorAll('.summary__count').forEach(el => { el.textContent = count; });
            document.querySelectorAll('.item__count').forEach(el => { el.textContent = cart.item_count; });
            popup.querySelectorAll('.summary__subtotal-place').forEach(el => { el.textContent = (cart.total_price/100).toFixed(2); });
          } catch { review(labels.summary_failed); }
        } catch {
          if (added) review(labels.added);
          else { uncertain = true; review(labels.uncertain); }
        } finally {
          busy = false;
          controls.forEach((el,i) => { el.disabled = uncertain || disabled[i]; });
        }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
